import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Route, Router } from '@angular/router';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-level1menu',
  templateUrl: './level1menu.component.html',
  styleUrls: ['./level1menu.component.css']
})
export class Level1menuComponent implements OnInit {

  @Output() change = new EventEmitter();
  menuList: any;
  selectedItem: any;
  userRole: any;
  UserName: any;
  data: any;

  constructor(private router: Router, private userService: UserService) { }

  ngOnInit() {
    debugger
    this.userRole = localStorage.getItem('userRole');
    this.UserName = localStorage.getItem('userName');
    this.menuList = localStorage.getItem('menuList');
    this.menuList = JSON.parse(this.menuList);

    let selectedMenuId = localStorage.getItem('selectedMenu');
    if (selectedMenuId != null && selectedMenuId != '' && typeof (selectedMenuId) != undefined)
      this.selectedItem = selectedMenuId;
    else {
      if (this.menuList.length != 0)
        this.selectedItem = this.menuList[0].KM_MenuId;
    }
  }

  listClick(event, newValue, KM_Id) {
    debugger
    localStorage.setItem('selectedMenu', newValue);
    this.selectedItem = newValue;
  }
  Logout() {
    this.LogoutDetails()
    localStorage.clear();
    this.change.emit(true);
    this.router.navigate(['/login']);
  }

  LogoutDetails() {
    debugger
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.LogoutDetails();
    this.data.subscribe(
      (response: any) => {
        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/level1menu/level1menu.component.ts